import styled from 'styled-components';

export const TooltipContent = styled.span`
  display: block;
  text-align: left;
  white-space: pre-line;
  font-size: 0.75rem;
`;
